import React, { FunctionComponent } from 'react'

import { getFeatureToggles, useConfig } from '../../../../state/configuration'
import { usePaymentSchedule } from '../../paymentScheduleContext'
import { useProduct } from '../../productContext'
import { CheckoutDisabled } from './CheckoutDisabled'
import { CheckoutManager } from './CheckoutManager'
import { CheckoutPage } from './CheckoutPage'

export const CheckoutRoute: FunctionComponent = () => {
  const {
    product: { payment },
  } = useProduct()

  const { disableBind } = useConfig(getFeatureToggles)
  const { paymentScheduleType } = usePaymentSchedule()

  const paymentScheduleConfig = payment?.schedules?.find(
    (it) => it.type === paymentScheduleType,
  )

  return paymentScheduleConfig && !disableBind ? (
    <CheckoutManager>
      <CheckoutPage config={paymentScheduleConfig} />
    </CheckoutManager>
  ) : (
    <CheckoutDisabled />
  )
}
